export interface EntityProperty {
  entityAspect?: <T>() => T;
}
export const isBreezeEntity = <T extends EntityProperty>(obj: T) => obj && obj.entityAspect;
